<template>
  <div class="live-course-statistics">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>统计分析</el-breadcrumb-item>
          <el-breadcrumb-item>直播课程统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>直播课程统计</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input v-model="keyword"
                  size="small"
                  placeholder="请输入医院名称"
                  width="264"
                  class="key-word"></el-input>
        <span>年份/月份:</span>
        <el-date-picker v-model="date"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="请选择">
        </el-date-picker>
        <el-button class="search"
                   type="primary"
                   size="small"
                   @click="search">查询</el-button>
        <el-button size="small"
                   @click="reset">重置</el-button>
      </div>
      <div class="table">
        <template>
          <el-table :data="tableData"
                    v-loading="loading"
                    show-summary
                    :summary-method="getSummaries"
                    style="width:100%;">
            <el-table-column label="序号"
                             align="center"
                             prop="id">
            </el-table-column>
            <el-table-column label="月份"
                             align="center"
                             prop="date">
            </el-table-column>
            <el-table-column label="医院名称"
                             align="center"
                             prop="hospitalName">
            </el-table-column>
            <el-table-column label="参加次数"
                             align="center"
                             prop="count">
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      keyword: "",
      date: "",
      tableData: [],
      loading: true
    }
  },
  created() {
    this.getTableData(this.keyword, this.date)
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      let countSum = 0
      data.forEach(item => {
        countSum += Number.parseFloat(item.count)
      })
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        if (index === 1) {
          sums[index] = ''
          return
        }
        if (index === 2) {
          sums[index] = ''
          return
        }
        if (index === 3) {
          sums[index] = `${countSum}次`
          return
        }
      })
      return sums
    },
    search() {
      if (this.keyword || this.date) {
        this.getTableData(this.keyword, this.date);
      }
    },
    reset() {
      this.keyword = ''
      this.date = ''
      this.getTableData(this.keyword, this.date)
    },
    getTableData(keyword, date) {
      this.loading = true
      let params = {}
      if (keyword != undefined) {
        params.keyword = keyword
      }
      if (date != undefined) {
        params.date = date
      }
      this.Axios.get("/api/Statistics/LiveBroadcast", { params })
        .then(res => {
          const data = res.data
          if (data.status == 100) {
            this.tableData = data.data
            this.total = data.total
            this.loading = false
          } else if (data.Status == 400) {
            this.$message({
              showClose: true,
              message: data.Message,
              type: "error"
            })
          } else {
            this.$message({
              showClose: true,
              message: data.message,
              type: "error"
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
};
</script>

<style lang="less">
.live-course-statistics {
  .table-info {
    .breadcrumb {
      overflow: hidden;
      span,
      .el-breadcrumb {
        float: left;
      }
      span {
        font-size: 14px;
        color: #666;
        line-height: 1;
      }
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      .search {
        margin-left: 20px;
        span {
          color: white;
        }
      }
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .date {
        width: 264px;
        margin-right: 20px;
      }
    }
    .table {
      margin-top: 40px;
      .apply-doc-header {
        .el-input {
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Statistics/LiveCourseStatistics.vue